import { ChangeEvent, Dispatch, SetStateAction } from 'react';

import {
  DeviceTarget,
  MutationParams,
  Project,
  ProjectService,
  ProjectType,
  TeamService,
} from 'entities';

import { AppSelectChangeEvent } from 'components/Blocks';

import { FormControlDispatchAction } from 'hooks';

export type ProjectTypeConfig = Pick<
  Project,
  'waves' | 'type' | 'shadowBanInWaves' | 'originProject'
>;

export type ProjectCreationProps = Omit<MutationParams['projects.createProject'], 'services'> & {
  services: (ProjectService & { name: string; baseCosts: TeamService['costVariables'] })[];
};

export type CreateProjectDispatchAction = FormControlDispatchAction<ProjectCreationProps>;

export interface StepComponentProps {
  state: ProjectCreationProps;
  dispatch: CreateProjectDispatchAction;
  setStep: Dispatch<SetStateAction<number>>;
  handleChange: (
    event:
      | ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
      | AppSelectChangeEvent<boolean>,
  ) => void;
}

export const defaultCreationProps: ProjectCreationProps = {
  name: '',
  client: '',
  clientOrigin: '',
  ticket: '',
  salesPerson: '',
  deviceTarget: '' as DeviceTarget,
  estimatedCompletionWorkingDays: 0,

  typeConfig: {
    type: '' as ProjectType,
    waves: 0,
    shadowBanInWaves: 0,
    originProject: '',
  },

  services: [],

  countries: [],
  currency: '',
  files: [],
  minFee: undefined,
  teamResponsible: '',

  observations: {
    bidsNotes: '',
    clientNotes: '',
    // this should be kept true for now
    reprice: true,
    repriceDetails: 'NO',
    recruitment: false,
    recruitmentDetails: '',
  },

  demographics: {},

  readyToInvoice: false,
};
